import { colors, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import { GrowthTrend } from '../types';
export const trendColor = {
  positive: colors.lime100,
  neutral: cbSemanticCssVars.textSecondary,
  negative: colors.strawberry100,
};
const Trend = styled(T.Small)<{ trend: GrowthTrend }>`
  color: ${props => trendColor[props.trend]};
  font-weight: 600;
`;

export default Trend;
